module.exports = __webpack_public_path__ + "media/assets/icons/caretDown-37ad7662e55457cd1db2a7765aefcbd6.svg";